import React, { useState } from 'react';
import { UploadIcon, FileIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
interface FileUploadProps {
  onFileUpload: (file: File) => void;
}
export function FileUpload({
  onFileUpload
}: FileUploadProps) {
  const [file, setFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const handleFileChange = e => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setFile(selectedFile);
      onFileUpload(selectedFile);
    }
  };
  const handleDragOver = e => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleDrop = e => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && droppedFile.type === 'application/pdf') {
      setFile(droppedFile);
      onFileUpload(droppedFile);
    }
  };
  return <div className="space-y-4" data-id="element-180">
      <div data-id="element-181">
        <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-182">
          Upload Floor Plan
        </h3>
        <p className="text-xs text-gray-500 mb-4" data-id="element-183">
          Upload a PDF file with the room measurements
        </p>
        <div className={`border-2 border-dashed rounded-lg p-6 text-center ${isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-blue-400'}`} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} data-id="element-184">
          {!file ? <>
              <UploadIcon className="h-10 w-10 text-gray-400 mx-auto mb-3" data-id="element-185" />
              <p className="text-sm text-gray-500 mb-2" data-id="element-186">
                Drag & drop a PDF file here
              </p>
              <p className="text-xs text-gray-400 mb-4" data-id="element-187">or</p>
              <label className="cursor-pointer bg-blue-50 text-blue-600 py-2 px-4 rounded-md hover:bg-blue-100 inline-block" data-id="element-188">
                <span data-id="element-189">Browse Files</span>
                <input type="file" className="hidden" accept="application/pdf" onChange={handleFileChange} data-id="element-190" />
              </label>
            </> : <div className="flex items-center justify-center" data-id="element-191">
              <div className="flex items-center bg-green-50 text-green-600 py-2 px-4 rounded-md" data-id="element-192">
                <FileIcon className="h-5 w-5 mr-2" data-id="element-193" />
                <span className="text-sm" data-id="element-194">{file.name}</span>
                <CheckCircleIcon className="h-5 w-5 ml-2 text-green-500" data-id="element-195" />
              </div>
            </div>}
        </div>
      </div>
      {file && <button onClick={() => setFile(null)} className="flex items-center justify-center text-sm text-red-600 hover:text-red-700" data-id="element-196">
          <XCircleIcon className="h-4 w-4 mr-1" data-id="element-197" />
          <span data-id="element-198">Remove File</span>
        </button>}
      <div className="border-t border-gray-200 pt-4" data-id="element-199">
        <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-200">Notes</h3>
        <ul className="text-xs text-gray-500 space-y-1 list-disc list-inside" data-id="element-201">
          <li data-id="element-202">Only PDF files are supported</li>
          <li data-id="element-203">It's recommended to upload an accurate measurement plan</li>
          <li data-id="element-204">After uploading, you can mark the room walls on the plan</li>
          <li data-id="element-205">Make sure the plan includes clear room dimensions</li>
        </ul>
      </div>
    </div>;
}